'use strict';

var configPromise = require('../config').configPromise;
var Api = require('./api');

var MENU_URL = '/api/menu';
var MENU_URL_GET_QUERY = '?module={0}';
var MENU_FILTER = '/api/ofsted/inspection-centre/task-filters/lookup';

var _clone = function (item) {
  return JSON.parse(JSON.stringify(item)); //return cloned copy so that the item is passed by value instead of by reference
};

var mocks = require('./mocks/menu/menuMocks');

var MenuApi = {

  /** GET api/Menu?module={module} */
  getMenu: function (module) {
    return configPromise
      .then(function (config) {
        return Api.get(config.apiPath(MENU_URL + MENU_URL_GET_QUERY, [module]));
      });
  },

  getMenuFilters: function () {
    return configPromise
      .then(function (config) {
        return Api.get(config.apiPath(MENU_FILTER));
      });
  },

};

module.exports = MenuApi;
